import React,{useState,useEffect} from 'react';
import { Form, Input, Button,Card, Row, Col } from 'antd';
import { VehicleDto } from '@gtpl/shared-models/masters';
import { VehicleService } from '@gtpl/shared-services/masters';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { Link, useHistory } from "react-router-dom";

import './vehicle-master-form.css';

/* eslint-disable-next-line */
export interface VehicleMasterFormProps {
  vehiclesData : VehicleDto;
  updateVehicle : (vehicle:VehicleDto) => void;
  isUpdate : boolean;
  closeForm: () => void;
}

export function VehicleMasterForm(
  props: VehicleMasterFormProps
) {
  const [form] = Form.useForm();
  let history = useHistory();
  const [disable, setDisable] = useState<boolean>(false)
  let createdUser="";
  if(!props.isUpdate){
    createdUser= localStorage.getItem("createdUser");
  }

  const vehicleService = new VehicleService()

  const createVehicle=(vehicleData:VehicleDto)=>{
    vehicleData.createdUser=localStorage.getItem('username')
    setDisable(true)
    vehicleService.createVehicle(vehicleData).then(res => {
      setDisable(false)
      if (res.status) {
        AlertMessages.getSuccessMessage('Vehicle Created Successfully');
        history.push("/vehicle-grid");
        onReset();
      } else {
        if (res.intlCode) {
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      setDisable(false)
      AlertMessages.getErrorMessage(err.message);
    })
  }

  const onReset=()=>{
    form.resetFields();
    
  }

  const saveData = (values: VehicleDto) => {
    setDisable(false)
    if(props.isUpdate){
      console.log(values)
      props.updateVehicle(values);
    }else{
      setDisable(false)
      console.log(values)
      createVehicle(values);
    }
  };

  return (
    <Card title={<span style={{color:'white'}}> Vehicles</span>} style={{textAlign:'center'}} headStyle={{backgroundColor: '#69c0ff', border: 0 }} extra={props.isUpdate==true?"":<Link to='/vehicle-grid' ><Button className='panel_button' >View </Button></Link>}
    >
      <Form layout="vertical" form={form} initialValues={props.vehiclesData} name="control-hooks" onFinish={saveData}>
      <Form.Item name="vehicleId" style={{display:"none"}} >
        <Input hidden/>
      </Form.Item>
    <Form.Item style={{display:"none"}} name="createdUser"  initialValue={createdUser}>
      <Input hidden/>
    </Form.Item>
    <Row gutter={24}>
        
    <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:8}} xl={{span:8}}>
            <Form.Item
                name="vehicleName"
                label="Vehicle Name"
                rules={[
                  {
                    required: true,message:'Vehicle Name is required'
                    
                  },
                  {
                    pattern: /^[^-\s\\0-9\[\]()*!@#$^&_\-+/%=`~{}:";'<>,.?|][a-zA-Z ]*$/,
                    message: `Should contain only alphabets.`
                  }
                ]}>
                <Input/>
              </Form.Item>
        </Col>
        <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:8}} xl={{span:8}}>
            <Form.Item
                name="registrationNumber"
                label="Registration Number"
                rules={[
                  {
                    required: true,message:'Registration Number is required'
                    
                  },
                  {
                    pattern: /^[^-\s\\[\]()*!@#$^&_\-+/%=`~{}:";'<>,.?|][a-zA-Z\\0-9\[\]()@#$_\-+/`~{}:";'<>,.?|\s-]*$/,
                    message: 'Invalid Registration number'
                  }
                ]}>
                <Input/>
              </Form.Item>
        </Col>
      </Row>
     
        <Col span={24} style={{ textAlign: 'right' }}>
          
            <Button type="primary" disabled={disable} htmlType="submit" >
              Submit
            </Button>
            {(props.isUpdate===false) &&
         <Button htmlType="button" style={{ margin: '0 14px' }} onClick={onReset}>
            Reset
          </Button>
          }
      
            
        </Col>
      </Form>
    </Card>
  );
}

export default VehicleMasterForm;
